import React, { useState } from "react";
import "../static/css/Contact.css";
import API_URL from "../config";

function Contact() {
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phoneNumber) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phoneNumber.replace(/\s/g, ""));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });

    // Validation
    if (!name.trim() || !mail.trim() || !phone.trim()) {
      setMessage({ type: "error", text: "All fields are required" });
      return;
    }

    if (!validateEmail(mail)) {
      setMessage({ type: "error", text: "Please enter a valid email address" });
      return;
    }

    if (!validatePhone(phone)) {
      setMessage({ type: "error", text: "Please enter a valid 10-digit phone number" });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name.trim(),
          email: mail.trim(),
          phone: phone.trim(),
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: "success", text: data.message });
        // Clear form fields
        setName("");
        setMail("");
        setPhone("");
      } else {
        setMessage({ type: "error", text: data.message || "Failed to submit form" });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage({
        type: "error",
        text: "Unable to connect to server. Please try again later."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="contact-container">
        <div className="contact-box">
          <div className="contact-address">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.3!2d76.9623!3d11.0167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDAxJzAwLjEiTiA3NsKwNTcnNDQuMyJF!5e0!3m2!1sen!2sin!4v1738829674000!5m2!1sen!2sin"></iframe>
            <div className="office-info">
              <h3>Main Office</h3>
              <p className="office-name">SPP Insolvency Professionals LLP,</p>
              <p>2nd Floor, CODisSIA G.D. Naidu Towers,</p>
              <p>Huzur Road, Coimbatore,</p>
              <p>Tamil Nadu, India - 641018</p>
              <br />
              <p><strong>Phone:</strong> +91 422 2319862 / 94888 1044</p>
              <p><strong>Email:</strong> <a href="mailto:info@sppgroupa.com">info@sppgroupa.com</a></p>
              <p><strong>Web:</strong> <a href="http://www.sppgroupa.com" target="_blank" rel="noopener noreferrer">www.sppgroupa.com</a></p>
              <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/company/spp-co-cba/" target="_blank" rel="noopener noreferrer">SPP & Co</a></p>
            </div>
          </div>
          <div className="vl"></div>
          <div className="contact-connect">
            <h4>Connect with Us</h4>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={loading}
                autoComplete="name"
              />
              <input
                type="email"
                placeholder="Email"
                value={mail}
                onChange={(e) => setMail(e.target.value)}
                disabled={loading}
                autoComplete="email"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={loading}
                autoComplete="tel"
              />

              {message.text && (
                <div className={`message ${message.type}`}>
                  {message.text}
                </div>
              )}

              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>

            <div className="contact-persons">
              <h4>Contact Persons:</h4>
              <p>CA S Prabhu: <a href="tel:+919488836000">+91 94888 36000</a></p>
              <p>CA N Suresh Kumar: <a href="tel:+917373052341">+91 73730 52341</a></p>
              <p>CA Prakash: <a href="tel:+919488845000">+91 94888 45000</a></p>
              <p>CA S Sidharth: <a href="tel:+918220596003">+91 82205 96003</a></p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;

